import { Component } from '@angular/core';
import { WindowService } from '@cigna/core/window';
import { FeatureTogglesFacade } from '@cigna/features';

@Component({
  selector: 'cigna-resources-app-header',
  templateUrl: './resources-app-header.component.html',
  styleUrls: ['./resources-app-header.component.scss'],
})
export class ResourcesAppHeaderComponent {
  pathname = this.window.location.pathname;

  isDental: boolean = this.pathname.startsWith('/assets/chcp/dental');
  isMedical: boolean = this.pathname.startsWith('/assets/chcp/medical');

  isSecure: boolean = this.isDental || this.isMedical;

  logoLink: string = this.isDental
    ? '/assets/chcp/dental/resourceLibrary/resourceLibraryDent.html'
    : this.isMedical
    ? '/assets/chcp/medical/resourceLibrary/resourceLibraryMed.html'
    : '/assets/chcp/resourceLibrary/resourceLibrary.html';

  constructor(
    private window: WindowService,
    private featureToggles: FeatureTogglesFacade,
  ) {}
}
